export default {"src":"/_next/static/media/smile-face.577f168d.svg","height":293,"width":293,"blurWidth":0,"blurHeight":0};